import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export const BD_UI_SIDE_SHEET_CONFIG_DEFAULT: DynamicDialogConfig = {
  position: 'center',
  modal: true,
  width: '70%',
  closable: true,
  closeOnEscape: true,
  maximizable: true,
  autoZIndex: true,
  baseZIndex: 1000,
  breakpoints: {
    '640px': '100%',
    '768px': '90%',
    '1024px': '85%',
    '1280px': '80%',
  },
};
